/**
 * i18n Basic translation
 * All kind of strings that are very used and shown in multiple apps
 */

import { Book } from '../../constants/translation';

// https://en.wikibooks.org/wiki/I_Ching/Interpretation
// https://en.wikibooks.org/wiki/I_Ching/Explanation_Of_I_Ching_Hexagrams_And_Lines
// @todo Traducción Legge es © by Ediciones Obelisco, S. L. 1997

const translation = {
  es: {
    authors:
      'James Legge, traducido al castellano por Nora Rodríguez © by Ediciones Obelisco, S. L. 1997',
    '1': {
      title: 'Khien',
      explanation:
        'Explicación de la figura completa por el rey Wan. Khien (representa) lo que es grande y generador, penetrante, ventajoso, correcto y firme.',
      lines: {
        explanation: 'Explicación de las líneas por el duque de Káu.',
        detail: [
          'En la primera (o inferior) línea entera (vemos al sujeto como) el dragón que permanece oculto (en la profundidad). No es el momento para la acción activa.',
          'En la segunda línea entera (vemos al sujeto como) el dragón que aparece en los campos. Será ventajoso entrevistarse con el gran hombre.',
          'En la tercera línea entera (vemos al sujeto como) el hombre superior activo y vigilante durante todo el día, y por la noche todavía cuidadoso y atentó. (La situación es) peligrosa, pero no habrá error.',
          'En la cuarta línea entera (vemos al sujeto como el dragón que mira), como disponiéndose a saltar, pero todavía en la profundidad. No habrá error.',
          'En la quinta línea entera (vemos al sujeto como) el dragón volando en el cielo. Será ventajoso entrevistarse con el gran hombre.',
          'En la sexta línea (la de arriba) entera (vemos al sujeto como) el dragón saliéndose de sus propios límites. Habrá ocasión para el arrepentimiento.',
          '(Las líneas de este hexagrama son todas ellas fuertes y enteras, según se deduce del) uso del número nueve. Si la multitud de dragones que aparecen se desposeyeran a sí mismos de sus cabezas, entonces habría buena fortuna.'
        ]
      }
    },
    '2': {
      title: 'Khwan'
    },
    n: {
      title: '',
      judgement: '',
      explanation: '',
      image: '',
      lines: {
        explanation: '',
        detail: ['', '', '', '', '', '', '']
      }
    }
  },
  en: {
    authors: 'James Legge',
    '1': {
      title: 'Khien'
    },
    '2': {
      title: 'Khwan'
    },
    n: {
      title: '',
      judgement: '',
      explanation: '',
      image: '',
      lines: {
        explanation: '',
        detail: ['', '', '', '', '', '', '']
      }
    }
  }
};

const book: Book = {
  id: 'Legge',
  translation
};

export default book;
